import * as React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Block } from '../Layout/Block'

interface Props {
  bordered?: boolean
  shadow?: boolean
  clickable?: boolean
  onClick?: () => void
}

const StyledContainer = styled.div<Props>`
  width: 100%;
  height: auto;
  background-color: ${p => p.theme.colors.white};
  padding: ${p => rem(p.theme.sizes.small)};
  margin: auto;
  border-radius: 45px;
  ${p =>
    p.bordered &&
    `
    border: 2px solid ${p.theme.colors.yellow};
  `};
  ${p =>
    p.shadow &&
    `
    box-shadow: 0 8px 40px ${p.theme.colors.lightGrey};
  `};
  ${p =>
    p.clickable &&
    `
    &:hover {
      cursor: pointer;
    }
  `}
`

export const RoundedBlock: React.SFC<Props> = ({ children, bordered, shadow, onClick, clickable }) => {
  return (
    <StyledContainer bordered={bordered} shadow={shadow} clickable={clickable} onClick={onClick}>
      <Block>{children}</Block>
    </StyledContainer>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/RoundedBlock/RoundedBlock.tsx